import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isEqual } from 'lodash-es';
import ReducerConstants from '../../../_shared/constants/reducers';
import { BidList } from './state';

const setBidList = (state, action: PayloadAction<BidList>) => {
  const newState = {
    ...state,
    ...action.payload
  };

  if (!isEqual(state, newState)) {
    return newState;
  }

  return state;
};

export const initialState = {};

export const bidSlice = createSlice({
  name: ReducerConstants.BID_LIST,
  initialState,
  reducers: {
    setBidList
  }
});

export default bidSlice.reducer;
